import React, { useState, useEffect, useContext } from "react";
import { AnchorComponent, ButtonComponent } from "../elements";
import { TranslatorContext } from "../../context/Translator";
import { useNavigate } from "react-router-dom";
import { deleteCountry } from "../../APIs/SettingRequests";
import { toast } from 'react-toastify';


export default function CountriesTableComponent({ thead, tbody,refreshPage }) {

    const [data, setData] = useState([]);
    const { t } = useContext(TranslatorContext);
    const navigate = useNavigate();
    useEffect(()=> { setData(tbody) }, [tbody]);

    const handleRowClick = (item) => {
        navigate(`/countries/${item.id}/cities`,{ state:{name:item.name}});
    };
    const handleDelete = (item) => {
        deleteCountry(item.id).then((res) => {
            //console.log(res.data.data);
            const notify = () => toast.success(res.data.message);
            notify();
            refreshPage();
        }).catch((error) => {
            console.log(error);
        }).finally(() => {
        });
    }
    
    return (
        <div className="mc-table-responsive">
            <table className="mc-table">
                <thead className="mc-table-head primary">
                    <tr>
                        {thead.map((item, index) => (
                            <th key={ index }>{ item }</th>
                        ))}
                    </tr>
                </thead>
                <tbody className="mc-table-body even">
                    {data?.map((item, index) => (
                        <tr key={ index }> 
                            <td title={ item.id }>
                                <div className="mc-table-profile">
                                    <p>{t(item.id) }</p>
                                </div>
                            </td>
                            <td title={ item.name }>{ item.name }</td>
                           
                            <td>
                                <div className="mc-table-action">
                                    <AnchorComponent onClick={() => handleRowClick(item)} to={'#'} title="View" className="material-icons view">{ "visibility" }</AnchorComponent>
                                    {/* <ButtonComponent title="Delete" className="material-icons delete" onClick={() => handleDelete(item)}>{ "delete" }</ButtonComponent> */}
                                
                                </div>
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>
            
        </div>
    )
}